import { createContext, useContext } from 'react';

export const FormTabsContext = createContext({
  sidebar: false,
  value: undefined as string | undefined,
  change: (_value: string) => {},
  indicatorId: '',
});
export const useDashboardPageFormTabs = () => useContext(FormTabsContext);
